module.exports = __webpack_public_path__ + "img/sharedLine.png?d752bc4a58d14e9bc4eeb1c2d0a3e3ec";